import { Autocomplete, Box, Button, Dialog, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { DateField, LocalizationProvider, frFR } from "@mui/x-date-pickers";
import { COLORS, output } from "../settings/themeSettings";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompagnieVol } from "../data/slices/compagnieVolSlice";

// Compagnies par défaut — affichées si la liste en base est vide
const DEFAULT_COMPAGNIES = [
    'Air Sénégal', 'Air France', 'Air Côte d\'Ivoire', 'Air Maroc (RAM)',
    'Ethiopian Airlines', 'Kenya Airways', 'Brussels Airlines', 'Corsair',
    'Transavia', 'Turkish Airlines', 'Emirates', 'Qatar Airways',
    'Air Algérie', 'Tunisair', 'Nouvelair', 'Afriqiyah Airways',
    'South African Airways', 'RwandAir', 'ASKY Airlines', 'Ceiba Intercontinental'
];



const styles = {
    container: {
        // border: '1px solid blue',
        minHeight: '1000px',
        width: '1000px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: COLORS.gray[100],
        padding: '15px',
        borderRadius: '5px',
        height: 'fit-content'

    },
    pathtitle: {
        fontSize: '1em',
        fontWeight: 'bold',
        padding: '0 10px',
        width: '100%',
        color: COLORS.tertiary
    },
    path: {
        width: '300px',
        height: '100%',
        //  border: '1px solid red'
    }
}



function AddTicketDialog(props) {

    const { compagnieVolsName: compagniesFromDB } = useSelector((state) => state.compagnieVols);

    // Fusionner les compagnies de la base avec les compagnies par défaut, sans doublons
    const options = compagniesFromDB && compagniesFromDB.length > 0
        ? [...new Set([...compagniesFromDB, ...DEFAULT_COMPAGNIES])].sort()
        : DEFAULT_COMPAGNIES;

    const { onClose, open } = props;
    const typesBillets = ["aller_simple", "aller_retour"];
    const classes = ["Business", "Premium", "Classe économie"];

    const [classe, setClasse] = useState(classes[0]);
    const [classeRetour, setClasseRetour] = useState(classes[0]);



    const [compagnie, setCompagnie] = useState(options[0] || '');
    const [compagnieRetour, setCompagnieRetour] = useState('');
    const [numero, setNumero] = useState('');
    const [trajet, setTrajet] = useState('');
    const [numeroVol, setNumeroVol] = useState('');
    const [numeroVolRetour, setNumeroVolRetour] = useState('');
    const [dateVol, setDateVol] = useState(null);
    const [dateVolRetour, setDateVolRetour] = useState(null);
    const [tarif, setTarif] = useState('');
    const [nom, setNom] = useState('');
    const [montantAchat, setMontantAchat] = useState('');
    const [montantEncaisse, setMontantEncaisse] = useState('');
    const [commentaire, setCommentaire] = useState('');

    const [type, setType] = useState(typesBillets[0]);

    const handleClose = (event, reason) => {
        if (reason && reason === "backdropClick")
            return;
        onClose();
    };
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchCompagnieVol());
    }, [dispatch]);

    const addTicket = () => {
        let ticketInfos = {
            id: props.ticket?.id || null,
            type,
            numero,
            trajet,
            numeroVol,
            dateVol: dateVol && ((typeof dateVol === 'string') ? dateVol : dateVol.toISOString().split('T')[0]),
            compagnie,
            numeroVolRetour,
            dateVolRetour: dateVolRetour && ((typeof dateVolRetour === 'string') ? dateVolRetour : dateVolRetour.toISOString().split('T')[0]),
            classe,
            classeRetour,
            compagnieRetour,
            nom,
            tarif,
            montantAchat,
            etat: 'OPEN',
            montantEncaisse: montantEncaisse || tarif,
            commentaire
        }
        //  output(ticketInfos);
        onClose(ticketInfos);
    }

    useEffect(() => {
        output(props);

        if (props.ticket) {
            setCompagnie(props.ticket.compagnie || '');
            setClasse(props.ticket.classe || '');
            setClasseRetour(props.ticket.classeRetour || '');
            setCompagnieRetour(props.ticket.compagnieRetour || '');
            setTrajet(props.ticket.trajet || '');
            setNumero(props.ticket.numero || '');
            setNom(props.ticket.nom || '');
            setMontantAchat(props.ticket.montantAchat || '');
            setTarif(props.ticket.tarif || '');
            setNumeroVol(props.ticket.numeroVol || '');
            setNumeroVolRetour(props.ticket.numeroVolRetour || '');
            props.ticket.type && setType(props.ticket.type);

            setDateVol(props.ticket.dateVol);
            setDateVolRetour(props.ticket.dateVolRetour);
            setCommentaire(props.ticket.commentaire || '');
            setMontantEncaisse(props.ticket.montantEncaisse || '');
        } else {
            setCompagnie('');
            setClasse('');
            setClasseRetour('');
            setCompagnieRetour('');
            setTrajet('');
            setNumero(props.lastTicket?.numero || props.defaultPnr || '');
            setDateVol(null);
            setDateVolRetour(null);
            setMontantAchat('');
            setTarif('');
            setCommentaire('');
            setMontantEncaisse('');
            setNom(props.lastTicket?.nom || props.defaultNom || '');
        }
    }, [props.ticket, props.lastTicket, props.open, props.defaultPnr, props.defaultNom]);



    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}
        >

            <Dialog onClose={handleClose} open={open} maxWidth={'lg'} PaperProps={{ sx: { minWidth: '700px' } }} >
                <DialogTitle
                    sx={{
                        backgroundColor: COLORS.secondary,
                        color: 'white',
                        mb: 5
                    }}
                >Ajouter un billet</DialogTitle>
                <Stack
                    direction="row"
                    sx={{
                        height: (type === "aller_retour") ? '700px' : '500px',
                        pl: 2,
                    }}
                >
                    <Box
                        width={'300px'}
                    >
                        <Typography
                            variant="p"
                            sx={styles.pathtitle}

                        >
                            Information Aller
                        </Typography>

                        <Autocomplete
                            value={type || null}
                            onChange={(event, newValue) => {
                                setType(newValue || '');
                            }}
                            inputValue={type || ''}
                            onInputChange={(event, newInputValue) => {
                                setType(newInputValue);
                            }}
                            options={typesBillets}
                            sx={{ width: 300, mt: '15px' }}

                            color="secondary"
                            renderInput={(params) => <TextField {...params} label="Type de billet" />}
                            clearIcon={false}

                        />
                        <TextField

                            margin="normal"
                            required
                            fullWidth
                            name="PNR"
                            label="PNR"
                            InputProps={{ style: { height: '45px' } }}
                            color="secondary"
                            focused
                            placeholder='Référence PNR'
                            value={numero}
                            onChange={(e) => setNumero(e.target.value)}

                        />
                        <TextField

                            margin="normal"
                            required
                            fullWidth
                            name="Trajet"
                            label="Trajet"
                            InputProps={{ style: { height: '45px' } }}
                            color="secondary"
                            focused
                            placeholder='Trajet (ex: DKR-DSS-PAR)'
                            value={trajet}
                            onChange={(e) => setTrajet(e.target.value)}

                        />

                        <Autocomplete
                            value={compagnie || null}
                            onChange={(event, newValue) => {
                                setCompagnie(newValue || '');
                            }}
                            inputValue={compagnie || ''}
                            onInputChange={(event, newInputValue) => {
                                setCompagnie(newInputValue);
                            }}
                            options={options}
                            sx={{ width: 300, mt: '15px' }}

                            color="secondary"
                            renderInput={(params) => <TextField {...params} label="Compagnie aérienne" />}
                            clearIcon={false}

                        />


                        <TextField

                            margin="normal"
                            required
                            fullWidth
                            name="Numéro vol"
                            label="Numéro vol"
                            InputProps={{ style: { height: '45px' } }}
                            color="secondary"
                            focused
                            placeholder='Numéro de vol'
                            value={numeroVol}
                            onChange={(e) => setNumeroVol(e.target.value)}

                        />


                        <DateField
                            label="Date du vol"
                            color="secondary"
                            focused
                            fullWidth
                            sx={{ mt: 2.5 }}
                            InputProps={{ style: { height: '45px' } }}
                            value={dateVol ? dayjs(dateVol) : null}
                            onChange={(e) => setDateVol(e)}
                            format="DD-MM-YYYY"
                        // defaultValue={dayjs(new Date())}


                        />

                        <Autocomplete
                            value={classe || null}
                            onChange={(event, newValue) => {
                                setClasse(newValue || '');
                            }}
                            inputValue={classe || ''}
                            onInputChange={(event, newInputValue) => {
                                setClasse(newInputValue);
                            }}
                            options={classes}
                            sx={{ width: 300, mt: '15px' }}

                            color="secondary"
                            renderInput={(params) => <TextField {...params} label="Classe" />}
                            clearIcon={false}

                        />

                    </Box>

                    {
                        (type === "aller_retour") && (
                            <Box
                                width={'300px'}
                            >
                                <Typography
                                    variant="p"
                                    sx={styles.pathtitle}

                                >
                                    Information Retour
                                </Typography>
                                <Autocomplete
                                    value={compagnieRetour || null}
                                    onChange={(event, newValue) => {
                                        setCompagnieRetour(newValue || '');
                                    }}
                                    inputValue={compagnieRetour || ''}
                                    onInputChange={(event, newInputValue) => {
                                        setCompagnieRetour(newInputValue);
                                    }}
                                    options={options}
                                    sx={{ width: 300, mt: '15px' }}

                                    color="secondary"
                                    renderInput={(params) => <TextField {...params} label="Compagnie aérienne retour" />}
                                    clearIcon={false}

                                />


                                <TextField

                                    margin="normal"
                                    required
                                    fullWidth
                                    name="Numéro vol"
                                    label="Numéro vol retour"
                                    InputProps={{ style: { height: '45px' } }}
                                    color="secondary"
                                    focused
                                    placeholder='Numéro de vol retour'
                                    value={numeroVolRetour}
                                    onChange={(e) => setNumeroVolRetour(e.target.value)}

                                />


                                <DateField
                                    label="Date du vol retour"
                                    color="secondary"
                                    focused
                                    fullWidth
                                    sx={{ mt: 2.5 }}
                                    InputProps={{ style: { height: '45px' } }}
                                    value={dateVolRetour ? dayjs(dateVolRetour) : null}
                                    onChange={(e) => setDateVolRetour(e)}
                                    format="DD-MM-YYYY"
                                // defaultValue={dayjs(new Date())}


                                />

                                <Autocomplete
                                    value={classeRetour || null}
                                    onChange={(event, newValue) => {
                                        setClasseRetour(newValue || '');
                                    }}
                                    inputValue={classeRetour || ''}
                                    onInputChange={(event, newInputValue) => {
                                        setClasseRetour(newInputValue);
                                    }}
                                    options={classes}
                                    sx={{ width: 300, mt: '15px' }}

                                    color="secondary"
                                    renderInput={(params) => <TextField {...params} label="Classe retour" />}
                                    clearIcon={false}

                                />

                            </Box>
                        )
                    }

                    <Box
                        width={'300px'}
                    >
                        <Typography
                            variant="p"
                            sx={styles.pathtitle}

                        >
                            Détails tarifaires et passager
                        </Typography>

                        <TextField

                            margin="normal"
                            required
                            fullWidth
                            name="Nom passager"
                            label="Nom passager"
                            InputProps={{ style: { height: '45px' } }}
                            color="secondary"
                            focused
                            placeholder='Nom complet du passager'
                            value={nom}
                            onChange={(e) => setNom(e.target.value)}

                        />
                        <TextField

                            margin="normal"
                            required
                            fullWidth
                            name="Tarif"
                            label="Tarif de vente"
                            InputProps={{ style: { height: '45px' } }}
                            color="secondary"
                            focused
                            placeholder='Tarif TTC (CFA)'
                            type='number'
                            value={tarif}
                            onChange={(e) => setTarif(e.target.value)}

                        />
                        <TextField

                            margin="normal"
                            required
                            fullWidth
                            name="Montant achat"
                            label="Montant achat"
                            InputProps={{ style: { height: '45px' } }}
                            color="secondary"
                            focused
                            placeholder='Montant achat net (CFA)'
                            type='number'
                            value={montantAchat}
                            onChange={(e) => setMontantAchat(e.target.value)}

                        />
                        <TextField

                            margin="normal"
                            required
                            fullWidth
                            name="Montant encaissé"
                            label="Acompte encaissé"
                            InputProps={{ style: { height: '45px' } }}
                            color="secondary"
                            focused
                            placeholder='Montant déjà encaissé (CFA)'
                            type='number'
                            value={montantEncaisse}
                            onChange={(e) => setMontantEncaisse(e.target.value)}

                        />

                        <TextField
                            margin="normal"
                            fullWidth
                            name="Commentaire"
                            label="Commentaire"
                            InputProps={{ style: { height: '45px' } }}
                            color="secondary"
                            placeholder='Commentaire libre'
                            value={commentaire}
                            onChange={(e) => setCommentaire(e.target.value)}
                        />

                    </Box>
                </Stack>
                <Stack
                    direction="row"
                    justifyContent="flex-end"
                    spacing={2}
                    sx={{
                        mt: 4,
                        pb: 5,
                        pr: 2
                    }}

                >


                    <Button
                        variant="contained"
                        color="primary"
                        style={{ color: 'white' }}
                        onClick={handleClose}
                    >
                        Annuler
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={addTicket}
                    >
                        {props.ticket ? 'Mettre à jour' : 'Valider'}
                    </Button>

                </Stack>

            </Dialog>
        </LocalizationProvider>

    );
}


export default AddTicketDialog;
